import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import Tab from '../Tab';
import Layout from '../Layout';
import ErrorAlert from '../../components/ErrorAlert';
import { get, remove, resetState } from '../../modules/types';
import { buildCategoryPath } from '../../utils';

class TypesTab extends Tab {
  columns = [
    { key: 'id', title: 'ID', dataIndex: 'id' },
    {
      key: 'name',
      title: 'Name',
      dataIndex: 'name',
      render: (name, data) => {
        return (
          <span>
            <Link to={`/types/${data.id}`}>
              {buildCategoryPath(name, data, this.props.data.results, 0)}
            </Link>
          </span>
        );
      },
    },
    this.tableActions(),
  ];

  render() {
    return (
      <Layout>
        <ErrorAlert error={this.props.error} />
        <div className="container-md">
          <Row>
            <Col>
              {this.renderDataTable()}
            </Col>
          </Row>
        </div>
      </Layout>
    );
  }
}

export default connect(state => state.types, { get, remove, resetState })(TypesTab);



// WEBPACK FOOTER //
// ./src/containers/Types/TypesTab.js